import { forwardRef, ReactElement } from 'react'
import Delete from '@mui/icons-material/Delete'
import { IconButton, IconButtonProps, Tooltip } from '@mui/material'

interface Props extends IconButtonProps {
  tooltip?: string
  enterDelay?: number
}

const DeleteIconButton = forwardRef<HTMLButtonElement, Props>(
  ({ tooltip, enterDelay, size = 'small', color = 'error', ...props }, ref): ReactElement => {
    const button = (
      <IconButton ref={ref} size={size} color={color} {...props}>
        <Delete />
      </IconButton>
    )

    if (!tooltip) {
      return button
    }

    return (
      <Tooltip title={tooltip} enterDelay={enterDelay}>
        {button}
      </Tooltip>
    )
  },
)

DeleteIconButton.displayName = 'DeleteIconButton'

export default DeleteIconButton
